<template>
  <div v-click-outside="() => (isOpenLoginMenu = false)" class="relative">
    <button
      @click="handleLoginTypeMenu"
      class="w-[max-content] group flex justify-center bg-[initial] xl:p-0 items-center h-[32px] md:h-[44px] hover:text-secondary rounded-[5px] p-1 xl:min-w-[120px]"
      :class="{ 'text-secondary-pressed': isOpenLoginMenu }"
    >
      <div class="md:flex justify-center w-[24px] h-[24px] md:w-[32px] md:h-[32px]">
        <icon-profile
          class="group-active:text-secondary-pressed group-hover:text-secondary text-[#242D21]"
          :class="{ 'text-secondary-pressed': isOpenLoginMenu }"
        />
      </div>
      <span
        class="text-[18px] font-medium font-Montserrat hidden xl:block group-active:text-secondary-pressed group-hover:text-secondary"
        >{{ $t("common.login") }}</span
      >
      <icon-arrow-list
        class="hidden xl:block ml-2 w-[12px] h-[12px]"
        :class="{
          'rotate-180': isOpenLoginMenu,
        }"
      />
    </button>
    <div
      v-show="isOpenLoginMenu"
      class="absolute xl:left-0 left-auto right-0 xl:right-auto xl:top-[100%] top-[105%] bg-white z-[99999] py-[12px] px-4 border-secondary border-[2px] rounded-[0.625rem] flex flex-col gap-2"
    >
      <button
        v-for="loginType in loginTypes"
        :key="loginType.value"
        type="button"
        class="w-[max-content] gap-[8px] flex items-center text-black group leading-none"
        @click="gotoLogin(loginType.value)"
      >
        <component :is="loginType.icon" class="group-hover:text-secondary-hover w-6 h-6" />
        <span class="shrink-0 xl:text-[18px] text-[16px] underline group-hover:text-secondary-hover">{{ $t(loginType.label) }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue"
import { useRouter } from "vue-router"

import IconManagerAcc from "components/icons/IconManagerAcc.vue"
import IconProfile from "components/icons/IconProfile.vue"
import IconVendorAcc from "components/icons/IconVendorAcc.vue"

const MANAGER_LOGIN_PLACEHOLDER = "https://manager-afterschool.com/login"

const loginTypes = [
  {
    value: "customer",
    label: "common.customer",
    icon: IconProfile,
  },
  {
    value: "provider",
    label: "common.provider",
    icon: IconVendorAcc,
  },
  {
    value: "supervisor",
    label: "common.supervisor",
    icon: IconManagerAcc,
  },
]

const router = useRouter()
const isOpenLoginMenu = ref(false)

const handleLoginTypeMenu = (): void => {
  isOpenLoginMenu.value = !isOpenLoginMenu.value
}

const gotoLogin = (type: string) => {
  isOpenLoginMenu.value = false

  if (type === "customer") {
    router.push({ name: "/login" })
    return
  }

  if (type === "provider" || type === "supervisor") {
    window.open(MANAGER_LOGIN_PLACEHOLDER, "_blank")
  }
}
</script>
